import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
import { LogOut, ArrowLeftToLine } from "lucide-react";
import UserAvatar from "~/components/UserAvatar";
import { type User } from "~/context/AuthContext";
import { useNavigate } from "~/lib/team-router";

interface ProfileDropdownProps {
  user: User;
  handleLogout: () => Promise<void>;
}

export default function ProfileDropdown({
  user,
  handleLogout,
}: ProfileDropdownProps) {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/onboarding");
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="p-2 cursor-pointer text-xs lg:text-sm font-medium flex items-center justify-center gap-2">
          <UserAvatar
            name={[user.first_name, user.last_name].filter(Boolean).join(" ")}
            email={user.email}
            picture={user.picture}
            className="size-4 lg:size-6"
            fallbackClassName="text-[8px] lg:text-[10px]"
          />
          {user.first_name || "Unnamed"}
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {user.is_creating_team && (
          <DropdownMenuItem
            onSelect={handleGoHome}
            className="flex items-center gap-2 cursor-pointer"
          >
            <ArrowLeftToLine className="h-4 w-4" />
            Home
          </DropdownMenuItem>
        )}
        <DropdownMenuItem
          onSelect={handleLogout}
          className="flex items-center gap-2 cursor-pointer"
        >
          <LogOut className="h-4 w-4" />
          <span>Logout</span>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
